import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react'; // Optional icons

export default function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      q: "Is my money safe?",
      a: "Yes! We use bank-level encryption and store funds in cold wallets. Your assets are insured up to $250,000."
    },
    {
      q: "How do I deposit funds?",
      a: "Go to Wallet → Deposit → Choose USD or crypto → Follow the instructions. Instant for crypto, 1–3 days for bank."
    },
    {
      q: "What fees do you charge?",
      a: "0% deposit fee. 0.5% trading fee. Free withdrawals (limits apply). No hidden charges."
    },
    {
      q: "Can I trade on mobile?",
      a: "Yes! Our app is fully responsive. Trade, deposit, and withdraw from any device."
    },
    {
      q: "How do I contact support?",
      a: "Click the chat icon in the bottom-right or email support@SwiftVault.com  We reply in under 5 minutes."
    },
    {
      q: "Is KYC required?",
      a: "Yes, for withdrawals over $2,000. Upload ID in Settings → KYC. Takes 2 minutes."
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-white to-gray-50">
  <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex flex-col md:flex-row items-start justify-between mb-12">
      {/* Left Side: Title and Description */}
      <div className="md:w-1/3 text-left mb-6 md:mb-0">
        <h2 className="text-3xl sm:text-4xl font-bold text-primary">
          Frequently Asked Questions
        </h2>
        <p className="mt-3 text-lg text-gray-600">
          Everything you need to know about SwiftVault
        </p>
      </div>

      {/* Right Side: Questions and Answers */}
      <div className="md:w-2/3 space-y-4">
        {faqs.map((faq, index) => (
          <div
            key={index}
            className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
          >
            {/* Question - Clickable */}
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full px-6 py-5 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
              aria-expanded={openIndex === index}
            >
              <h3 className="text-lg font-semibold text-primary pr-4">
                {faq.q}
              </h3>
              <span className="text-primary transition-transform duration-200">
                {openIndex === index ? (
                  <ChevronUp className="w-5 h-5" />
                ) : (
                  <ChevronDown className="w-5 h-5" />
                )}
              </span>
            </button>

            {/* Answer - Animated */}
            <div
              className={`overflow-hidden transition-all duration-300 ease-in-out ${
                openIndex === index ? 'max-h-96' : 'max-h-0'
              }`}
            >
              <div className="px-6 pb-5 pt-2">
                <p className="text-gray-600 leading-relaxed">
                  {faq.a}
                </p>
              </div>
            </div>
          </div>
        ))}

        {/* Contact Link */}
        <div className="text-center mt-10">
          <p className="text-gray-600">
            Still have questions?{" "}
            <a href="/contact" className="text-primary font-medium hover:underline">
              Contact us
            </a>
          </p>
        </div>
      </div>
    </div>
  </div>
</section>
  );
}